<template>
  <div class="hold-transition">
    <!-- Modal para nueva/editar tarifa -->
    <div
      class="modal fade"
      ref="modalNuevaTarifa"
      id="modalNuevaTarifa"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left text-white pt-2 pb-2">
            <h5 class="modal-title">
              <i class="fas fa-plus mr-2"></i>
              {{ form.id ? "Editar" : "Nueva" }} Tarifa
            </h5>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label for="nombre" class="font-weight-bold">
                    <i class="fas fa-tag mr-1"></i>Nombre:
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    id="nombre"
                    v-model="form.nombre"
                    :class="$v.form.nombre.$invalid ? 'is-invalid' : 'is-valid'"
                    placeholder="Ingrese el nombre de la tarifa"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="font-weight-bold">
                    <i class="fas fa-map-marker-alt mr-1"></i>Bloque:
                  </label>
                  <v-select
                    :class="[
                      $v.form.bloque_id.$invalid ? 'is-invalid' : 'is-valid',
                      $store.getters.getDarkMode ? 'dark-vselect' : '',
                    ]"
                    v-model="bloque"
                    placeholder="Seleccione un bloque"
                    label="nombre"
                    class="form-control p-0"
                    :options="$parent.listasForms.bloques"
                    @input="getSelectBloque()"
                  >
                  </v-select>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="font-weight-bold">
                    <i class="fas fa-map-marker-alt mr-1"></i>Sitio Destino:
                  </label>
                  <v-select
                    :class="[
                      $v.form.sitio_destino_id.$invalid
                        ? 'is-invalid'
                        : 'is-valid',
                      $store.getters.getDarkMode ? 'dark-vselect' : '',
                    ]"
                    v-model="sitio_destino"
                    placeholder="Seleccione un sitio destino"
                    label="nombre"
                    class="form-control p-0"
                    :options="$parent.listasForms.sitios_destino"
                    @input="getSelectSitioDestino()"
                  >
                  </v-select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label class="font-weight-bold">
                    <i class="fas fa-truck mr-1"></i>Tipo de Vehículo:
                  </label>
                  <v-select
                    :class="[
                      $v.form.tipo_vehiculo_id.$invalid
                        ? 'is-invalid'
                        : 'is-valid',
                      $store.getters.getDarkMode ? 'dark-vselect' : '',
                    ]"
                    v-model="tipo_vehiculo"
                    placeholder="Seleccione tipo de vehículo"
                    label="nombre"
                    class="form-control p-0"
                    :options="$parent.listasForms.tipos_vehiculos"
                    @input="getSelectTipoVehiculo()"
                  >
                  </v-select>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label for="km" class="font-weight-bold">
                    <i class="fas fa-tachometer-alt mr-1"></i>Kilometraje:
                  </label>
                  <input
                    type="number"
                    step="any"
                    class="form-control"
                    id="km"
                    v-model="form.km"
                    :class="$v.form.km.$invalid ? 'is-invalid' : 'is-valid'"
                    placeholder="0.00"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label class="font-weight-bold">
                    <i class="fas fa-cogs mr-1"></i>Categoría:
                  </label>
                  <v-select
                    :class="[
                      $v.form.categoria.$invalid ? 'is-invalid' : 'is-valid',
                      $store.getters.getDarkMode ? 'dark-vselect' : '',
                    ]"
                    v-model="categoria"
                    placeholder="Seleccione categoría"
                    label="descripcion"
                    class="form-control p-0"
                    :options="$parent.listasForms.categorias"
                    @input="getSelectCategoria()"
                  >
                  </v-select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label class="font-weight-bold">
                    <i class="fas fa-play mr-1"></i>Tipo de Operación:
                  </label>
                  <v-select
                    :class="[
                      $v.form.tipo_operacion.$invalid
                        ? 'is-invalid'
                        : 'is-valid',
                      $store.getters.getDarkMode ? 'dark-vselect' : '',
                    ]"
                    v-model="tipo_operacion"
                    placeholder="Seleccione operación"
                    label="descripcion"
                    class="form-control p-0"
                    :options="$parent.listasForms.tipo_operaciones"
                    @input="getSelectTipoOperacion()"
                  >
                  </v-select>
                </div>
              </div>
              <div class="col-md-4" v-if="form.tipo_operacion == 1">
                <div class="form-group">
                  <label class="font-weight-bold">
                    <i class="fas fa-tint mr-1"></i>Producto Líquido:
                  </label>
                  <v-select
                    :class="[
                      $v.form.producto_liquido_id.$invalid
                        ? 'is-invalid'
                        : 'is-valid',
                      $store.getters.getDarkMode ? 'dark-vselect' : '',
                    ]"
                    v-model="producto_liquido"
                    placeholder="Seleccione producto líquido"
                    label="nombre"
                    class="form-control p-0"
                    :options="$parent.listasForms.productos"
                    @input="getSelectProductoLiquido()"
                  >
                  </v-select>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              <i class="fas fa-times mr-1"></i>
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="save()"
              :disabled="$v.form.$invalid"
              v-if="
                $store.getters.can('hidrocarburos.tarifarios.tarifaCreate') ||
                  $store.getters.can('hidrocarburos.tarifarios.tarifaSave')
              "
            >
              <i class="fas fa-save mr-1" v-if="!$parent.cargando"></i>
              <i class="fas fa-spinner fa-spin mr-1" v-else></i>
              {{ form.id ? "Actualizar" : "Guardar" }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";
import { required } from "vuelidate/lib/validators";

export default {
  name: "TarifarioAsignarTarifa",
  components: {
    vSelect,
  },
  data() {
    return {
      bloque: {},
      producto_liquido: {},
      sitio_destino: {},
      tipo_vehiculo: {},
      categoria: {},
      tipo_operacion: {},
      form: {
        id: null,
        nombre: null,
        tarifario_id: null,
        producto_liquido_id: null,
        tipo_vehiculo_id: null,
        bloque_id: null,
        sitio_destino_id: null,
        valor_tarifa: null,
        categoria: null,
        km: null,
        tipo_operacion: null,
      },
    };
  },

  validations() {
    let producto_liqui = {};
    if (this.form.tipo_operacion == 1) {
      producto_liqui = {
        required,
      };
    } else {
      producto_liqui = {
        required: false,
      };
    }

    return {
      form: {
        nombre: {
          required,
        },
        tipo_vehiculo_id: {
          required,
        },
        bloque_id: {
          required,
        },
        producto_liquido_id: producto_liqui,
        sitio_destino_id: {
          required,
        },
        categoria: {
          required,
        },
        km: {
          required,
        },
        tipo_operacion: {
          required,
        },
      },
    };
  },

  methods: {
    save() {
      if (!this.$v.form.$invalid) {
        this.$parent.cargando = true;
        axios({
          method: "POST",
          url: "/api/hidrocarburos/tarifarios/saveTarifa",
          data: this.form,
        })
          .then((res) => {
            this.$parent.cargando = false;
            if (res.data.status == 0) {
              this.$swal({
                icon: "error",
                title: res.data.msg,
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
            } else {
              this.$swal({
                icon: "success",
                title: "La tarifa se guardó exitosamente",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
              // Cerrar modal y actualizar tabla
              this.$refs.modalNuevaTarifa.click();
              this.limpiarFormulario();
              this.$parent.cargarTarifas();
            }
          })
          .catch((e) => {
            this.$swal({
              icon: "error",
              title:
                "Ha ocurrido un error, por favor intente la acción nuevamente." +
                e,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            this.$parent.cargando = false;
          });
      }
    },

    limpiarFormulario() {
      this.form = {
        id: null,
        tarifario_id: this.$parent.$parent.form.id,
        producto_liquido_id: null,
        tipo_vehiculo_id: null,
        bloque_id: null,
        sitio_destino_id: null,
        nombre: null,
        categoria: null,
        km: null,
        tipo_operacion: null,
      };
      this.bloque = {};
      this.producto_liquido = {};
      this.sitio_destino = {};
      this.tipo_vehiculo = {};
      this.categoria = {};
      this.tipo_operacion = {};
    },

    getSelectBloque() {
      this.form.bloque_id = null;
      if (this.bloque) {
        this.form.bloque_id = this.bloque.id;
      }
    },

    getSelectSitioDestino() {
      this.form.sitio_destino_id = null;
      if (this.sitio_destino) {
        this.form.sitio_destino_id = this.sitio_destino.id;
      }
    },

    getSelectTipoVehiculo() {
      this.form.tipo_vehiculo_id = null;
      if (this.tipo_vehiculo) {
        this.form.tipo_vehiculo_id = this.tipo_vehiculo.id;
      }
    },

    getSelectCategoria() {
      this.form.categoria = null;
      if (this.categoria) {
        this.form.categoria = this.categoria.numeracion;
      }
    },

    getSelectTipoOperacion() {
      this.form.tipo_operacion = null;
      if (this.tipo_operacion) {
        this.form.tipo_operacion = this.tipo_operacion.numeracion;
      }
    },

    getSelectProductoLiquido() {
      this.form.producto_liquido_id = null;
      if (this.producto_liquido) {
        this.form.producto_liquido_id = this.producto_liquido.id;
      }
    },
  },
};
</script>
